/**
 * Ilustraciones animadas (SVG + CSS) para tarjetas de costos por perfil.
 */

export type PricingTierId = 'colaboradores' | 'clientes' | 'empresas';

function wrap(classSuffix: string, svg: string): HTMLElement {
  const wrap = document.createElement('div');
  wrap.className = `sv-price-card__art sv-price-card__art--${classSuffix}`;
  wrap.setAttribute('aria-hidden', 'true');
  wrap.innerHTML = svg;
  return wrap;
}

function illColaboradores(): string {
  return `<svg class="sv-price-card-svg" viewBox="0 0 240 160" xmlns="http://www.w3.org/2000/svg" focusable="false">
  <defs>
    <linearGradient id="prcColOrb" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" stop-color="#ce93d8" stop-opacity="0.35"/>
      <stop offset="100%" stop-color="#6a1b9a" stop-opacity="0.15"/>
    </linearGradient>
    <linearGradient id="prcColW" x1="0%" y1="0%" x2="100%" y2="0%">
      <stop offset="0%" stop-color="#9e9e9e"/>
      <stop offset="100%" stop-color="#e0e0e0"/>
    </linearGradient>
  </defs>
  <ellipse cx="120" cy="88" rx="92" ry="68" fill="url(#prcColOrb)"/>
  <g class="sv-prc-ill sv-prc-ill--ring">
    <circle cx="120" cy="82" r="44" fill="none" stroke="#e1bee7" stroke-width="8"/>
    <circle class="sv-prc-ill__arc" cx="120" cy="82" r="44" fill="none" stroke="#8e24aa" stroke-width="8" stroke-linecap="round"
      stroke-dasharray="41.5 235" transform="rotate(-90 120 82)"/>
  </g>
  <text class="sv-prc-ill sv-prc-ill--pct" x="120" y="92" text-anchor="middle" font-size="22" font-weight="800" fill="#6a1b9a" font-family="system-ui,sans-serif">15%</text>
  <g transform="translate(158, 52)">
    <g class="sv-prc-ill sv-prc-ill--wrench">
      <path d="M4 14h36l5-6 5 6h14v12H50l-5 6-5-6H4V14z" fill="url(#prcColW)" stroke="#616161" stroke-width="1.4"/>
      <circle cx="72" cy="20" r="16" fill="url(#prcColW)" stroke="#616161" stroke-width="2"/>
      <circle cx="72" cy="20" r="7" fill="#5d4037" opacity="0.2"/>
    </g>
  </g>
  <g class="sv-prc-ill sv-prc-ill--coins">
    <circle cx="62" cy="118" r="14" fill="#ffb300" stroke="#f57c00" stroke-width="2"/>
    <circle cx="76" cy="108" r="14" fill="#ffca28" stroke="#f9a825" stroke-width="2"/>
    <path d="M62 112v12M56 118h12" stroke="#f57c17" stroke-width="1.6" stroke-linecap="round"/>
  </g>
</svg>`;
}

function illClientes(): string {
  return `<svg class="sv-price-card-svg" viewBox="0 0 240 160" xmlns="http://www.w3.org/2000/svg" focusable="false">
  <defs>
    <linearGradient id="prcCliOrb" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" stop-color="#a5d6a7" stop-opacity="0.4"/>
      <stop offset="100%" stop-color="#43a047" stop-opacity="0.12"/>
    </linearGradient>
  </defs>
  <ellipse cx="120" cy="88" rx="92" ry="68" fill="url(#prcCliOrb)"/>
  <g class="sv-prc-ill sv-prc-ill--phone">
    <rect x="100" y="32" width="44" height="72" rx="10" fill="#fff" stroke="#6a1b9a" stroke-width="2.5"/>
    <rect x="106" y="42" width="32" height="44" rx="4" fill="#e8f5e9"/>
    <path d="M112 60l7 5 14-16" fill="none" stroke="#2e7d32" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
    <circle cx="122" cy="98" r="2.5" fill="#d1c4e9"/>
  </g>
  <g transform="translate(120, 102) scale(0.78) translate(-120, -102)">
    <g class="sv-prc-ill sv-prc-ill--heart">
      <path d="M120 124c-28-18-44-36-44-56 0-14 11-24 24-24 9 0 17 5 20 12 3-7 11-12 20-12 13 0 24 10 24 24 0 20-16 38-44 56z" fill="#e91e63" stroke="#c2185b" stroke-width="2.5"/>
    </g>
  </g>
  <g class="sv-prc-ill sv-prc-ill--sparkles" fill="#ffd54f" stroke="#ff8f00" stroke-width="1.2">
    <path d="M42 48l4 8 8 4-8 4-4 8-4-8-8-4 8-4z"/>
    <path d="M198 56l3 6 6 3-6 3-3 6-3-6-6-3 6-3z"/>
    <path d="M52 128l2 4 4 2-4 2-2 4-2-4-4-2 4-2z"/>
  </g>
</svg>`;
}

function illEmpresas(): string {
  return `<svg class="sv-price-card-svg" viewBox="0 0 240 160" xmlns="http://www.w3.org/2000/svg" focusable="false">
  <defs>
    <linearGradient id="prcEmpOrb" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" stop-color="#b39ddb" stop-opacity="0.4"/>
      <stop offset="100%" stop-color="#5e35b1" stop-opacity="0.18"/>
    </linearGradient>
  </defs>
  <ellipse cx="120" cy="88" rx="92" ry="68" fill="url(#prcEmpOrb)"/>
  <g class="sv-prc-ill sv-prc-ill--building">
    <rect x="68" y="58" width="44" height="72" rx="3" fill="#7e57c2" stroke="#4a148c" stroke-width="2"/>
    <rect x="72" y="66" width="10" height="10" fill="#e1bee7" opacity="0.9"/>
    <rect x="86" y="66" width="10" height="10" fill="#e1bee7" opacity="0.9"/>
    <rect x="100" y="66" width="10" height="10" fill="#e1bee7" opacity="0.9"/>
    <rect x="72" y="82" width="10" height="10" fill="#e1bee7" opacity="0.9"/>
    <rect x="86" y="82" width="10" height="10" fill="#e1bee7" opacity="0.9"/>
    <rect x="100" y="82" width="10" height="10" fill="#e1bee7" opacity="0.9"/>
    <rect x="86" y="96" width="10" height="22" fill="#4a148c"/>
    <rect x="128" y="44" width="52" height="86" rx="3" fill="#9575cd" stroke="#4a148c" stroke-width="2"/>
    <rect x="134" y="52" width="12" height="12" fill="#ede7f6"/>
    <rect x="150" y="52" width="12" height="12" fill="#ede7f6"/>
    <rect x="166" y="52" width="12" height="12" fill="#ede7f6"/>
    <rect x="134" y="70" width="12" height="12" fill="#ede7f6"/>
    <rect x="150" y="70" width="12" height="12" fill="#ede7f6"/>
    <rect x="166" y="70" width="12" height="12" fill="#ede7f6"/>
    <rect x="150" y="88" width="12" height="30" fill="#4a148c"/>
  </g>
  <g class="sv-prc-ill sv-prc-ill--chart" transform="translate(176, 60)">
    <rect x="0" y="32" width="12" height="22" rx="2" fill="#8e24aa" opacity="0.9"/>
    <rect x="16" y="20" width="12" height="34" rx="2" fill="#ab47bc"/>
    <rect x="32" y="8" width="12" height="46" rx="2" fill="#ba68c8"/>
  </g>
  <g class="sv-prc-ill sv-prc-ill--cycle" fill="none" stroke="#6a1b9a" stroke-width="2.5" stroke-linecap="round">
    <path d="M168 32c10 0 18 8 18 18s-8 18-18 18"/>
    <polyline points="182 30 188 36 182 42"/>
    <path d="M72 32c-10 0-18 8-18 18s8 18 18 18"/>
    <polyline points="58 30 52 36 58 42"/>
  </g>
</svg>`;
}

export function createPricingIllustration(tierId: PricingTierId): HTMLElement {
  if (tierId === 'colaboradores') {
    return wrap('colaboradores', illColaboradores());
  }
  if (tierId === 'clientes') {
    return wrap('clientes', illClientes());
  }
  return wrap('empresas', illEmpresas());
}
